
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-z17rmd",
"minContentWidth": "--awsui-min-content-width-z17rmd",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-z17rmd",
"contentGapLeft": "--awsui-content-gap-left-z17rmd",
"contentGapRight": "--awsui-content-gap-right-z17rmd",
"contentHeight": "--awsui-content-height-z17rmd",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-z17rmd",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-z17rmd",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-z17rmd",
"defaultMaxContentWidth": "--awsui-default-max-content-width-z17rmd",
"defaultMinContentWidth": "--awsui-default-min-content-width-z17rmd",
"drawerSize": "--awsui-drawer-size-z17rmd",
"drawerMinSize": "--awsui-drawer-min-size-z17rmd",
"bottomDrawerSize": "--awsui-bottom-drawer-size-z17rmd",
"footerHeight": "--awsui-footer-height-z17rmd",
"headerGap": "--awsui-header-gap-z17rmd",
"headerHeight": "--awsui-header-height-z17rmd",
"layoutWidth": "--awsui-layout-width-z17rmd",
"mainGap": "--awsui-main-gap-z17rmd",
"mainOffsetLeft": "--awsui-main-offset-left-z17rmd",
"mainTemplateRows": "--awsui-main-template-rows-z17rmd",
"mobileBarHeight": "--awsui-mobile-bar-height-z17rmd",
"notificationsHeight": "--awsui-notifications-height-z17rmd",
"offsetTop": "--awsui-offset-top-z17rmd",
"overlapHeight": "--awsui-overlap-height-z17rmd",
"navigationWidth": "--awsui-navigation-width-z17rmd",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-z17rmd",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-z17rmd",
"splitPanelHeight": "--awsui-split-panel-height-z17rmd",
"splitPanelMinWidth": "--awsui-split-panel-min-width-z17rmd",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-z17rmd",
"toolsMaxWidth": "--awsui-tools-max-width-z17rmd",
"toolsWidth": "--awsui-tools-width-z17rmd",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-z17rmd",
"contentScrollMargin": "--awsui-content-scroll-margin-z17rmd",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-z17rmd",
"flashbarStackIndex": "--awsui-flashbar-stack-index-z17rmd",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-z17rmd",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-z17rmd",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-z17rmd",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-z17rmd",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-z17rmd",
"dropdownContentBorderColor": "--awsui-dropdown-content-border-color-z17rmd",
"dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-z17rmd",
"dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-z17rmd",
"modalCustomWidth": "--awsui-modal-custom-width-z17rmd",
"modalCustomHeight": "--awsui-modal-custom-height-z17rmd",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-z17rmd",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-z17rmd",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-z17rmd",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-z17rmd",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-z17rmd",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-z17rmd",
"sliderLabelCount": "--awsui-slider-label-count-z17rmd",
"sliderTickCount": "--awsui-slider-tick-count-z17rmd",
"sliderReferenceColumn": "--awsui-slider-reference-column-z17rmd",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-z17rmd",
"sliderMaxStart": "--awsui-slider-max-start-z17rmd",
"sliderMinEnd": "--awsui-slider-min-end-z17rmd",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-z17rmd",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-z17rmd",
"togglesLeftWidth": "--awsui-toggles-left-width-z17rmd",
"togglesRightWidth": "--awsui-toggles-right-width-z17rmd",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-z17rmd",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-z17rmd",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-z17rmd",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-z17rmd",
"styleBackgroundActive": "--awsui-style-background-active-z17rmd",
"styleBackgroundDefault": "--awsui-style-background-default-z17rmd",
"styleBackgroundDisabled": "--awsui-style-background-disabled-z17rmd",
"styleBackgroundHover": "--awsui-style-background-hover-z17rmd",
"styleBorderColorActive": "--awsui-style-border-color-active-z17rmd",
"styleBorderColorDefault": "--awsui-style-border-color-default-z17rmd",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-z17rmd",
"styleBorderColorHover": "--awsui-style-border-color-hover-z17rmd",
"styleColorActive": "--awsui-style-color-active-z17rmd",
"styleColorDefault": "--awsui-style-color-default-z17rmd",
"styleColorDisabled": "--awsui-style-color-disabled-z17rmd",
"styleColorHover": "--awsui-style-color-hover-z17rmd",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-z17rmd",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-z17rmd",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-z17rmd",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-z17rmd",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-z17rmd",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-z17rmd",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-z17rmd",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-z17rmd",
"styleBackgroundReadonly": "--awsui-style-background-readonly-z17rmd",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-z17rmd",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-z17rmd",
"styleColorReadonly": "--awsui-style-color-readonly-z17rmd",
"styleBackgroundFocus": "--awsui-style-background-focus-z17rmd",
"styleBorderColorFocus": "--awsui-style-border-color-focus-z17rmd",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-z17rmd",
"styleColorFocus": "--awsui-style-color-focus-z17rmd",
"stylePlaceholderColor": "--awsui-style-placeholder-color-z17rmd",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-z17rmd",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-z17rmd",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-z17rmd",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-z17rmd",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-z17rmd",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-z17rmd",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-z17rmd",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-z17rmd",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-z17rmd",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-z17rmd",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-z17rmd",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-z17rmd",
"alertIconColor": "--awsui-alert-icon-color-z17rmd",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-z17rmd",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-z17rmd",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-z17rmd",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-z17rmd",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-z17rmd",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-z17rmd",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-z17rmd",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-z17rmd",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-z17rmd",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-z17rmd",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-z17rmd",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-z17rmd",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-z17rmd",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-z17rmd",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-z17rmd",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-z17rmd",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-z17rmd",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-z17rmd",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-z17rmd",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-z17rmd",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-z17rmd",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-z17rmd",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-z17rmd",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-z17rmd",
"promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-z17rmd",
"promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-z17rmd",
"promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-z17rmd",
"promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-z17rmd",
"optionBackgroundDefault": "--awsui-option-background-default-z17rmd",
"optionBackgroundHighlighted": "--awsui-option-background-highlighted-z17rmd",
"optionBackgroundSelected": "--awsui-option-background-selected-z17rmd",
"optionColorDefault": "--awsui-option-color-default-z17rmd",
"optionColorHighlighted": "--awsui-option-color-highlighted-z17rmd",
"optionColorDisabled": "--awsui-option-color-disabled-z17rmd",
"optionGroupLabelColor": "--awsui-option-group-label-color-z17rmd",
"optionFilterMatchBackground": "--awsui-option-filter-match-background-z17rmd",
"optionFilterMatchColor": "--awsui-option-filter-match-color-z17rmd",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-z17rmd",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-z17rmd",
"progressBarHeight": "--awsui-progress-bar-height-z17rmd",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-z17rmd",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-z17rmd",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-z17rmd",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-z17rmd",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-z17rmd",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-z17rmd",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-z17rmd",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-z17rmd",
"tokenStyleBackgroundDefault": "--awsui-token-style-background-default-z17rmd",
"tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-z17rmd",
"tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-z17rmd",
"tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-z17rmd",
"tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-z17rmd",
"tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-z17rmd",
"tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-z17rmd",
"tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-z17rmd",
"tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-z17rmd",
"tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-z17rmd",
"styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-z17rmd",
"styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-z17rmd",
"styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-z17rmd",
"styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-z17rmd",
"styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-z17rmd",
      };
      export default customCSSPropertiesMap;
    